import { render, staticRenderFns } from "./Behaviour.vue?vue&type=template&id=1fc592f6&scoped=true&"
import script from "./Behaviour.vue?vue&type=script&lang=js&"
export * from "./Behaviour.vue?vue&type=script&lang=js&"
import style0 from "./Behaviour.vue?vue&type=style&index=0&id=1fc592f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc592f6",
  null
  
)

export default component.exports